// extracted by mini-css-extract-plugin
export default {"head":"Experience_head__OnBP4","eBlock":"Experience_eBlock__3mqsO","Experience":"Experience_Experience__P0S4y","block":"Experience_block__3JolO","stack":"Experience_stack__6kymj"};